import { useTranslation } from 'react-i18next';
import { DateRangeEnd, DateSelectorType } from '../enums';
import { getMonthTextFromDateRangeEnd } from './getMonthTextFromDateRangeEnd';
import { IDateRangeSelectorDropdownOption } from './DateRangeSelector';

/**
 * Options for the dropdown that lets the user choose how they want to
 * select a date.
 */
export const useDatePickerOptions = (
  dateRangeEnd: DateRangeEnd
): IDateRangeSelectorDropdownOption[] => {
  const [t] = useTranslation(['search', 'translation']);

  return [
    {
      key: DateSelectorType.month,
      text: getMonthTextFromDateRangeEnd(dateRangeEnd, t),
    },
    {
      key: DateSelectorType.date,
      text: t('Specific day', {
        ns: 'search',
        defaultValue: 'Specific day',
      }),
    },
    {
      key: DateSelectorType.today,
      text: t('Today', {
        ns: 'search',
        defaultValue: 'Today',
      }),
    },
    {
      key: DateSelectorType.updatetuesday,
      text: t('datePickerUpdateTuesday', {
        defaultValue: 'Update Tuesday (2nd Tuesday of the month)',
        ns: 'search',
      }),
    },
  ];
};
